import { Control, FieldValues, UseFieldArrayRemove, UseFormWatch } from 'react-hook-form';
import { Button, Grid2, Stack, Typography } from '@mui/material';

import MinusIcon from 'components/v2/icons/MinusIcon';
import { InputField } from 'components/v2/input/InputField';
import { InputSelectField, SelectOption } from 'components/v2/input/InputSelectField';
import { LAYOUT_SPACING } from 'constants/ui/style';
import { useLocalization } from 'localization';
import InputPhoneNumber from 'components/v2/input/InputPhoneNumber';
import { getContactPersonTypesApi } from 'api/orders/query';

export type ContactPersonProps = {
  index: number;
  control: Control<FieldValues, any>;
  removeField: UseFieldArrayRemove;
  watch: UseFormWatch<FieldValues>;
};

const ContactPerson = (props: ContactPersonProps) => {
  const { index, removeField, control } = props;
  const { t } = useLocalization();

  const { data, isLoading } = getContactPersonTypesApi();

  const contactPersonTypeLabel: { [key: number]: string } = {
    0: t('orders.pages.new.stepThree.contactPersons.primary'),
    1: t('orders.pages.new.stepThree.contactPersons.secondary'),
    2: t('orders.pages.new.stepThree.contactPersons.tertiary'),
  };

  const contactPersonHeader = (index: number) => {
    return (
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h5" sx={{ fontSize: '1.2rem', fontWeight: 500 }}>
          {contactPersonTypeLabel[index]}
        </Typography>

        {index > 0 && (
          <Button
            variant="outlined"
            size="small"
            sx={{ width: 'fit-content', color: 'error.main' }}
            startIcon={<MinusIcon />}
            onClick={() => removeField(index)}
          >
            {t('common.actions.remove')}
          </Button>
        )}
      </Stack>
    );
  };

  return (
    <Stack gap={LAYOUT_SPACING.FORM.xs}>
      <Stack spacing={LAYOUT_SPACING.FORM.xs}>
        {contactPersonHeader(index)}
        <Grid2 container spacing={LAYOUT_SPACING.FORM.xs}>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <InputSelectField
              name={`contactPersons.${index}.type`}
              control={control}
              options={(data as SelectOption[]) ?? []}
              label="common.terms.contactType"
              menuHeight={300}
              required={false}
              loading={isLoading}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <InputField
              control={control}
              name={`contactPersons.${index}.name`}
              label="common.terms.name"
              required={false}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <InputPhoneNumber name={`contactPersons.${index}.phone`} control={control} required={false} />
          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <InputField control={control} name={`contactPersons.${index}.email`} label="common.terms.email" />
          </Grid2>
        </Grid2>
      </Stack>
    </Stack>
  );
};

export default ContactPerson;
